<template>
  <v-app id="app_live_tracking">
    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">NOT AVAILABLE SALES REP LIST</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">Analyse not available agents data.</p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="back()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="custom_card_box mt-8" elevation="1" border="sm opacity-1" rounded="lg">
        <template v-slot:item>
          <v-text-field v-model="search" density="comfortable" class="custom_input_field_color w-50 mt-5 ml-2"
                        label="Search" persistent-placeholder placeholder="Search" variant="outlined"></v-text-field>
        </template>

        <template v-slot:append>
          <v-divider vertical thickness="2"></v-divider>
          <v-card-text class="custom_tool_bar_style">
            <v-btn class=" custom_pdf_btn" variant="outlined" @click="exportPDF">
              <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
            </v-btn>
            <v-btn class="custom_excel_btn ml-4" variant="outlined" @click="exportExcel">
              <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
            </v-btn>
          </v-card-text>
        </template>

        <v-divider thickness="2"></v-divider>

        <v-card-text>
          <v-data-table :headers="headers" :items="filteredActiveAgents" class="custom_table_normal">
            <template v-slot:[`item.name`]="{ item }">
              <p class="text-caption custom_page_main_sub_title font-weight-bold">{{ item.name }}</p>
              <p class="custom_page_main_sub_title_very_small_red text-caption font-weight-medium mb-3">
                {{ item.user_code || '-' }}</p>
            </template>

            <template v-slot:[`item.area_codes`]="{ item }">
              <p class="text-caption font-weight-medium mb-3">{{ formatAreaCodes(item.area_codes) }}</p>
            </template>

            <template v-slot:[`item.day_in`]="{ item }">
              <p class="text-caption font-weight-medium mb-3">{{ formatDateValue(item.day_in) }}</p>
            </template>

            <template v-slot:[`item.day_out`]="{ item }">
              <p class="text-caption font-weight-medium mb-3">{{ formatDateValue(item.day_out) }}</p>
            </template>


            <template v-slot:[`item.states`]>
              <v-row>
                <v-col cols="12" md="12" lg="12">
                  <v-chip class="custom_red_chip" size="small" variant="outlined">
                    Not available
                    <v-icon class="justify-end ml-3" icon="mdi-close"></v-icon>
                  </v-chip>
                </v-col>
              </v-row>
            </template>

          </v-data-table>
        </v-card-text>
      </v-card>

    </v-container>
  </v-app>
</template>

<script>
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from "xlsx";
import axios from "axios";
import {getPermissions} from "@/plugins/permissions";

export default {
  data() {
    return {
      search: '',
      permissions: {},
      headers: [
        { text: 'SALES REP NAME', value: 'name', title: 'SALES REP NAME', sortable: true },
        { text: 'ADDRESS', value: 'address', title: 'ADDRESS', sortable: true },
        { text: 'AREA CODES', value: 'area_codes', title: 'AREA CODES', sortable: false },
        { text: 'MOBILE', value: 'mobile_number', title: 'MOBILE', sortable: true },
        { text: 'DAY IN', value: 'day_in', title: 'DAY IN', sortable: true },
        { text: 'DAY OUT', value: 'day_out', title: 'DAY OUT', sortable: true },
        { text: 'STATES', value: 'states', title: 'STATUS', sortable: false },

      ],
      activeAgents: [],
    }
  },

  computed: {
    filteredActiveAgents() {
      const query = (this.search || '').toLowerCase().trim();

      if (!query) {
        return this.activeAgents;
      }

      return this.activeAgents.filter((item) => {
        const areaCodes = Array.isArray(item.area_codes) ? item.area_codes.join(', ') : '';
        const dayIn = this.isEmptyValue(item.day_in) ? '' : String(item.day_in);
        const dayOut = this.isEmptyValue(item.day_out) ? '' : String(item.day_out);

        const searchableText = [
          item.name || '',
          item.user_code || '',
          item.address || '',
          item.mobile_number || '',
          areaCodes,
          dayIn,
          dayOut,
        ].join(' ').toLowerCase();

        return searchableText.includes(query);
      });
    },
  },

  mounted() {
    this.getAllAgents();
    const dashboardId = 7;
    this.permissions = getPermissions(dashboardId);
    console.log("Permissions:", this.permissions);
    this.getDashboardPermissions();
  },

  methods: {

    back() {
      this.$router.push('/live-tracking');
    },

    getDashboardPermissions() {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');

      axios.post(`/api/getDashboard?userId=${userId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the Authorization header with the Bearer token
            }
          })
          .then(response => {
            const dashboards = response.data.data;
            this.permissionsItems = dashboards.map(dashboard => ({
              id: dashboard.id,
              premission_dashboard: dashboard.premission_dashboard,
              isOn: false,
              permissions: {read: false, write: false, delete: false},
            }));
            console.log('Dashboard permissions:', this.permissionsItems);
          })
          .catch(error => {
            console.error('Error fetching dashboard permissions:', error);
          });
    },

    getAllAgents() {
      const token = localStorage.getItem('token');

      axios.get('/api/tracking/mobile-users', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
          .then(response => {
            if (response.status === 200) {
              const users = Array.isArray(response?.data?.data) ? response.data.data : [];
              const mappedUsers = users.map((item) => ({
                id: item.id,
                name: item.name || '-',
                user_code: item.user_code,
                address: item.address || '-',
                area_codes: Array.isArray(item.area_codes) ? item.area_codes : [],
                mobile_number: item.mobile_number || '-',
                day_in: item.day_in,
                day_out: item.day_out,
              }));
              this.activeAgents = mappedUsers.filter((item) => this.getAgentState(item) === 'not_available');

            } else {
              console.error("Error:", response.data.error);
            }
          })
          .catch(error => {
            console.error("Error fetching chart details:", error);
          });
    },

    isEmptyValue(value) {
      return value === null || value === undefined || String(value).trim() === '';
    },

    getAgentState(item) {
      const hasDayIn = !this.isEmptyValue(item.day_in);
      const hasDayOut = !this.isEmptyValue(item.day_out);
      return hasDayIn && !hasDayOut ? 'ongoing' : 'not_available';
    },

    formatAreaCodes(areaCodes) {
      if (!Array.isArray(areaCodes) || areaCodes.length === 0) {
        return '-';
      }
      return areaCodes.join(', ');
    },

    formatDateValue(value) {
      return this.isEmptyValue(value) ? '-' : value;
    },

    exportPDF() {
      const doc = new jsPDF();
      // Set title with improved styling
      doc.setFontSize(16);
      doc.text('Agent Report', 14, 20);
      // Subtitle or additional information
      doc.setFontSize(10);
      doc.text('Not available sales rep report with mobile tracking details', 14, 28);

      // Define the columns with better alignment
      const tableColumns = [
        'SALES REP NAME', 'User Code', 'Address', 'Area Codes', 'Mobile', 'Day In', 'Day Out', 'Status'
      ];

      // Prepare data for the table
      const tableData = this.activeAgents.map((item) => [
        item.name,
        item.user_code || '-',
        item.address || '-',
        this.formatAreaCodes(item.area_codes),
        item.mobile_number || '-',
        this.formatDateValue(item.day_in),
        this.formatDateValue(item.day_out),
        'Not available'
      ]);

      doc.autoTable({
        head: [tableColumns],
        body: tableData,
        startX: 35,
        theme: 'grid',
        headStyles: {
          fillColor: [40, 40, 200],
          textColor: [255, 255, 255],
          fontSize: 5,
          halign: 'center',
          valign: 'middle',
          cellPadding: 0.5,
        },
        bodyStyles: {
          fontSize: 5,
          textColor: [50, 50, 50],
          halign: 'center',
          valign: 'middle',
          cellPadding: 0.5,
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240],
        },
        columnStyles: {
          0: { cellWidth: 20 },
          1: { cellWidth: 16 },
          2: { cellWidth: 26 },
          3: { cellWidth: 25 },
          4: { cellWidth: 18 },
          5: { cellWidth: 20 },
          6: { cellWidth: 20 },
          7: { cellWidth: 18 },
        },
        margin: {top: 10},
      });

      // Footer with date
      doc.setFontSize(10);
      doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, doc.internal.pageSize.height - 10);

      // Save the PDF
      doc.save('Not_Available_Sales_Rep.pdf');
    },

    exportExcel() {
      // Prepare the data for Excel export
      const tableData = this.activeAgents.map((item) => ({
        'SALES REP NAME': item.name,
        'USER CODE': item.user_code || '-',
        'ADDRESS': item.address || '-',
        'AREA CODES': this.formatAreaCodes(item.area_codes),
        'MOBILE': item.mobile_number || '-',
        'DAY IN': this.formatDateValue(item.day_in),
        'DAY OUT': this.formatDateValue(item.day_out),
        'STATUS': 'Not available',
      }));

      if (tableData.length === 0) {
        const headers = ['SALES REP NAME', 'USER CODE', 'ADDRESS', 'AREA CODES', 'MOBILE', 'DAY IN', 'DAY OUT', 'STATUS'];
        tableData.push(headers.reduce((obj, header) => {
          obj[header] = '';
          return obj;
        }, {}));
      }

      // Create worksheet from JSON data
      const worksheet = XLSX.utils.json_to_sheet(tableData);

      // Set custom column widths
      worksheet['!cols'] = [
        { wch: 20 },
        { wch: 15 },
        { wch: 30 },
        { wch: 25 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 15 },
      ];

      // Freeze the header row
      worksheet['!freeze'] = {ySplit: 1};

      const headerRange = XLSX.utils.decode_range(worksheet['!ref']);
      for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({r: 0, c: C});
        if (!worksheet[cellAddress]) continue;
        worksheet[cellAddress].s = {
          font: {bold: true},
          alignment: {horizontal: 'center'},
        };
      }

      // Create a new workbook and add the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'All SALES REP Reports');

      // Save the workbook as an Excel file
      XLSX.writeFile(workbook, 'All_SALES_REP_Reports.xlsx');
    },
  },
};
</script>
